import React from "react";

import item1 from "../../assets/images/item1.png";
import item2 from "../../assets/images/item2.png";
import { getAllVendors } from "../../helper/backend-methods";
import { useNavigate } from "react-router-dom";

export default function FeaturedVendors() {
  const navigate = useNavigate();
  const [featuredVendors, setFeaturedVendors] = React.useState([]);

  const _getAllFeaturedVendors = async () => {
    try {
      const response = await getAllVendors({isFeatured: true});
      setFeaturedVendors(response.data.Status ? response.data.Data || [] : []);
    } catch (error) {
      setFeaturedVendors([]);
    }
  };


  React.useEffect(() => {
    // Fetch featured vendors from API and update state
    // For now, we will use the static data defined above
    _getAllFeaturedVendors();
  }, []);


  return (
    <section id="featured-vendors-section">
      <div className="wrapper">
        <div className="featured-vendors-header">
          <h2>FEATURED VENDORS</h2>

          <button type="button" onClick={() => navigate("/store/vendors")}>
            VIEW ALL VENDORS
          </button>
        </div>

        {featuredVendors.length === 0 ? (
          <div className="no-featured-vendors">
            <i className="ri-store-3-line"></i>
            <h3>No Vendors Available</h3>
            <p>We couldn't find any featured vendors right now — check back soon.</p>
          </div>
        ) : (
          <div className="featured-vendors-grid">
            {featuredVendors.map((vendor) => (
              <div key={vendor.VendorId} className="featured-vendor-card">
                <img src={vendor.VendorPicture?.Url || "static/media/mains-logo.6b089ddea9df137474bf.png"} alt={vendor.VendorName} />

                <h3>{vendor.VendorName}</h3>

                <p>{vendor.VendorDescription}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
